export const links = {
  methods: {
    externalLinks(text) {
      const search = "<a ";
      // eslint-disable-next-line quotes
      const replaceWith = '<a target="_blank" ';
      const result = text.split(search).join(replaceWith);
      return result;
    },
  },
};
